import { useSessionStyles } from '../useSessionStyles';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { appointmentBooksState, setAppointmentBooksState } from '../../../../../../store/reducers/appointments';
import clsx from 'clsx';
import AttendanceChip from '../../../../../../components/notes/component/attendanceChip';
import AgyleCheckBox from '../../../../../../components/ui/checkbox/agyleCheckBox';
import { setSnackbar } from '../../../../../../store/reducers/globals';
import OngoingSpellProgress from '../../../../../../components/admissions/ongoingSpellProgress';
import React from 'react';
import { APPOINTMENT_BOOK_TYPES, getAttendanceType } from '../../../../../ward/map/patientList/utils/edReviewUtils';
import { Chip } from '@mui/material';

const AppointmentAttendanceListItem = ({ attendance }) => {
    const classes = useSessionStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // Selector
    const bookState = useSelector(appointmentBooksState);

    const isSelected = bookState?.linkedAttendance?.__id === attendance?.admission?.__id;
    const isCanceled = attendance?.admission?.canceled;
    const isActive = !isCanceled && !attendance?.admission?.endDate;

    const handleSelect = () => {
        if (isSelected) {
            dispatch(
                setAppointmentBooksState({
                    linkedAttendance: null,
                    type: APPOINTMENT_BOOK_TYPES.NONE,
                }),
            );
        } else {
            dispatch(setSnackbar({ type: 'info', message: t('Linked to activity') }));
            dispatch(
                setAppointmentBooksState({
                    linkToActivity: true,
                    linkedAttendance: attendance?.admission,
                    type: null,
                    // type: getAttendanceType(attendance),
                }),
            );
        }
    };

    return (
        <div className={clsx(classes.attendanceListItem, isSelected && 'selected')} onClick={handleSelect}>
            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                {isActive && (
                    <OngoingSpellProgress
                        label={`${t('Active')} (${attendance?.areaDescription || '-'} / ${attendance?.bedDescription || '-'})`}
                        size="small"
                        disableDots
                    />
                )}

                {isCanceled && (
                    <div className={classes.divRow} style={{ width: '100%' }}>
                        <Chip label={t('Activity cancelled')} variant="outlined" style={{ background: '#E25B61', color: '#fff' }} />
                    </div>
                )}

                <AttendanceChip admission={attendance?.admission} showVisitNumber classesOverride={classes.chipOverride} />
            </div>

            <AgyleCheckBox value={isSelected} />
        </div>
    );
};

export default AppointmentAttendanceListItem;
